<template>
    <div class="photo-lower-bar-button-group">
        <div class="photo-lower-bar-button" v-show="canDeleted" v-on:click="deleteSelectedPlane()">
            <SVGPhotoDelete class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding" >Удалить</span>
        </div>
        <div class="photo-lower-bar-button" v-on:click="addPlatband()" v-show="platbandCompatible">
            <SVGAddAdditionalAuto class="lb-svg"/>
            <span class="photo-lower-bar-button-text extra-left-padding">Добавить наличник</span>
        </div>

    </div>
</template>

<script>
    import SVGPhotoDelete from "../../SVG/SVGPhotoDelete";
    import {bus} from "../../../vue_bus";
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow";
    import store from "../../../store";
    import {getFermatPolygon, translatePoints} from "../../../math/getAreaCorrected";
    import {getBackwardMatrix} from "../../../math/perspectiveTransform";
    import SVGAddAdditionalAuto from "../../SVG/SVGAddAdditionalAuto";
    import {planePointer} from "../../../fabric/primitives/planePointer";
    import {getPerspectivePoints} from "../../../fabric/libs/getPerspectivePoints";
    import {getPlatbandPoints} from "../../../fabric/libs/getPlatBandPoints";

    export default {
        name: "LeftLowerBarEditAdditional",
        components: {
            SVGAddAdditionalAuto,
            SVGAdminEditRow,
            SVGPhotoDelete
        },
        data() {
          return {
            removablePlaneTypes: ["additional", "platband"],
            platbandCompatiblePlanes: ["window", "door"],
          }
        },
        mounted() {

        },
        computed: {
            canDeleted() {
                if (!this.$store.getters["active/ACTIVE_PLANE"])
                    return false

              return this.removablePlaneTypes.includes(this.$store.getters["active/ACTIVE_PLANE"].type);
            },
            platbandCompatible() {
                if (!this.$store.getters["active/ACTIVE_PLANE"])
                    return false

              return this.platbandCompatiblePlanes.includes(this.$store.getters["active/ACTIVE_PLANE"].type);
            },
        },
        methods: {
            deleteSelectedPlane() {
              //TODO нужно перерендерить
                this.$store.dispatch('active/DELETE_PLANE');
                bus.$emit('refreshFabric');
                this.$router.replace({
                        name: "additional",
                        query: this.$route.query,
                    }).catch(()=>{});
            },
            async addPlatband() {
                const projectUUID = this.$route.params.projectUUID;
                const photoID = this.$route.params.photoID;
                const planeID = this.$route.params.planeID;
                const multiplier = 1.1;
                const sourcePoints = this.$store.getters["active/ACTIVE_PLANE"].points;
                let platbandPoints = getPlatbandPoints(sourcePoints, multiplier);
                let platbandPointsDict = {};
                for (let pointID in platbandPoints) {
                    platbandPointsDict[parseInt(pointID)+1] = {
                        x:platbandPoints[pointID].x,
                        y:platbandPoints[pointID].y,
                        link: platbandPoints[pointID].link,
                    }
                }

                store.dispatch(`active/ADD_PLANE`,
                    {
                        type: "platband",
                        perspectiveMatrix: this.$store.getters["active/ACTIVE_PLANE"].perspectiveMatrix,
                        idDesignGroup: this.$store.getters["active/ACTIVE_PLANE"].idDesignGroup,
                        perspectivePoints: this.$store.getters["active/ACTIVE_PLANE"].perspectivePoints,
                        subType: this.$store.getters["active/ACTIVE_PLANE"].type,
                        points: platbandPointsDict,
                        isComplete: true,
                    }).then(()=>{
                        bus.$emit("refreshFabric");
                })


            }
        }
    }
</script>

<style scoped>
    .sidebar-checkbox {
        line-height: unset;
        margin: auto;
    }

    .additional-auto-button {
        width: 22px;
        height: 22px;
    }
</style>
